// Generated from ops sheet snapshot 2026-11-01T08:10+07:00 — do not edit by hand.
window.SLQ_PRODUCTS = [
 {
  "handle": "aina-coconut-white-leather-handbag-biggest-sale-deal",
  "variantId": "67920530145556",
  "type": "handbag",
  "design": "Aina Coconut White",
  "size": "13.8×10.6×5.5\" · vừa laptop 13\", sách, ví dài, đồ dùng cả ngày",
  "list": 142.95,
  "p4": 28.59,
  "stock": 6207,
  "rank": 1,
  "giftSafe": true,
  "matching": [
   "aina-coconut-white-small-leather-handbag-biggest-sale-deal",
   "aina-coconut-white-leather-tote-bag-biggest-sale-deal",
   "aina-coconut-white-circle-crossbody-bag-bs26-deal",
   "aina-coconut-white-mini-satchel-biggest-sale-deal",
   "aina-coconut-white-wallet-biggest-sale-deal",
   "aina-coconut-white-mini-wallet-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Aina-Coconut-White_1.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/AinaWhite_LE_mk_1.png"
 },
 {
  "handle": "sanaa-salt-pop-leather-handbag-biggest-sale-deal",
  "variantId": "67920522739988",
  "type": "handbag",
  "design": "Sanaa Salt Pop",
  "size": "13.8×10.6×5.5\" · vừa laptop 13\", sách, ví dài, đồ dùng cả ngày",
  "list": 142.95,
  "p4": 28.59,
  "stock": 2150,
  "rank": 10,
  "giftSafe": true,
  "matching": [
   "sanaa-salt-pop-leather-tote-bag-biggest-sale-deal",
   "sanaa-salt-pop-circle-crossbody-bag-biggest-sale-deal",
   "sanaa-salt-pop-leather-backpack-biggest-sale-deal",
   "sanaa-salt-pop-wallet-biggest-sale-deal",
   "sanaa-salt-pop-mini-wallet-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Sanaa-Salt-Pop_1_81d7161d-c574-451a-8be1-5e33fd2e39af.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/SanaaWhite_LE_mk_1.png"
 },
 {
  "handle": "locella-leather-handbag-biggest-sale-deal",
  "variantId": "67920591388948",
  "type": "handbag",
  "design": "Locella",
  "size": "13.8×10.6×5.5\" · vừa laptop 13\", sách, ví dài, đồ dùng cả ngày",
  "list": 142.95,
  "p4": 28.59,
  "stock": 1309,
  "rank": 7,
  "giftSafe": false,
  "matching": [
   "locella-mini-satchel-bs26-deal",
   "locella-wallet-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Locella_1_6e9483d7-5a7a-47ec-89b1-93a12681179b.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Locella_LE_mk_1_939a0192-139a-47e7-8269-b199d6278f25.png"
 },
 {
  "handle": "njia-leather-handbag-biggest-sale-deal",
  "variantId": "67920579559700",
  "type": "handbag",
  "design": "Njia",
  "size": "13.8×10.6×5.5\" · vừa laptop 13\", sách, ví dài, đồ dùng cả ngày",
  "list": 142.95,
  "p4": 28.59,
  "stock": 1231,
  "rank": 9,
  "giftSafe": true,
  "matching": [
   "njia-leather-tote-bag-biggest-sale-deal",
   "njia-leather-backpack-biggest-sale-deal",
   "njia-mini-wallet-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Njia_1_528b5168-7ecb-4625-8642-7690864b8779.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Njia_mk_1_4dba012e-fee3-4479-84fe-033223962b49.png"
 },
 {
  "handle": "serwa-black-leather-handbag-bs26-deal",
  "variantId": "67949986382100",
  "type": "handbag",
  "design": "Serwa Black",
  "size": "13.8×10.6×5.5\" · vừa laptop 13\", sách, ví dài, đồ dùng cả ngày",
  "list": 178.95,
  "p4": 35.79,
  "stock": 365,
  "rank": 60,
  "giftSafe": true,
  "matching": [],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/serwa-black_mk_1.png",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/20260728-152105.png"
 },
 {
  "handle": "aina-coconut-white-small-leather-handbag-biggest-sale-deal",
  "variantId": "67919579119892",
  "type": "small handbag",
  "design": "Aina Coconut White",
  "size": "9.8×7.7×4.5\" · điện thoại, ví nhỏ, chìa khoá, son",
  "list": 131.95,
  "p4": 26.39,
  "stock": 2636,
  "rank": 1,
  "giftSafe": true,
  "matching": [
   "aina-coconut-white-leather-handbag-biggest-sale-deal",
   "aina-coconut-white-leather-tote-bag-biggest-sale-deal",
   "aina-coconut-white-circle-crossbody-bag-bs26-deal",
   "aina-coconut-white-mini-satchel-biggest-sale-deal",
   "aina-coconut-white-wallet-biggest-sale-deal",
   "aina-coconut-white-mini-wallet-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/aina-coconut-white-1.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/images_2Fmockups_2Faina-white_mk_1-3186237276.png"
 },
 {
  "handle": "aina-coconut-white-leather-tote-bag-biggest-sale-deal",
  "variantId": "67917919420692",
  "type": "tote",
  "design": "Aina Coconut White",
  "size": "18×12×11\" · vừa A4, laptop 13\", chai nước",
  "list": 119.95,
  "p4": 23.99,
  "stock": 1272,
  "rank": 1,
  "giftSafe": true,
  "matching": [
   "aina-coconut-white-leather-handbag-biggest-sale-deal",
   "aina-coconut-white-small-leather-handbag-biggest-sale-deal",
   "aina-coconut-white-circle-crossbody-bag-bs26-deal",
   "aina-coconut-white-mini-satchel-biggest-sale-deal",
   "aina-coconut-white-wallet-biggest-sale-deal",
   "aina-coconut-white-mini-wallet-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/AinaRise_SlayWhiteStudio1.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Aina-Coconut-White_mk_1_ae00651f-a451-4279-b534-7f5a759f7575.png"
 },
 {
  "handle": "sanaa-salt-pop-leather-tote-bag-biggest-sale-deal",
  "variantId": "67917931970836",
  "type": "tote",
  "design": "Sanaa Salt Pop",
  "size": "18×12×11\" · vừa A4, laptop 13\", chai nước",
  "list": 119.95,
  "p4": 23.99,
  "stock": 1182,
  "rank": 10,
  "giftSafe": true,
  "matching": [
   "sanaa-salt-pop-leather-handbag-biggest-sale-deal",
   "sanaa-salt-pop-circle-crossbody-bag-biggest-sale-deal",
   "sanaa-salt-pop-leather-backpack-biggest-sale-deal",
   "sanaa-salt-pop-wallet-biggest-sale-deal",
   "sanaa-salt-pop-mini-wallet-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/SanaaRise_SlayWhiteStudio1.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Sanaa-Salt-Pop_mk_1_c5852ca8-edbe-4cfc-8cda-c18d2571808e.png"
 },
 {
  "handle": "zuriya-leather-tote-bag-biggest-sale-deal",
  "variantId": "67917921714452",
  "type": "tote",
  "design": "Zuriya",
  "size": "18×12×11\" · vừa A4, laptop 13\", chai nước",
  "list": 119.95,
  "p4": 23.99,
  "stock": 521,
  "rank": 8,
  "giftSafe": true,
  "matching": [
   "zuriya-wallet-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/ZuriyaBeautifulStudio2_e5ba958a-04c2-4116-953e-7b1cca87c4c8.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Zuriya_mk_1_d76630a7-7d9c-461a-93d0-c7d0b49273da.png"
 },
 {
  "handle": "njia-leather-tote-bag-biggest-sale-deal",
  "variantId": "67918195032340",
  "type": "tote",
  "design": "Njia",
  "size": "18×12×11\" · vừa A4, laptop 13\", chai nước",
  "list": 119.95,
  "p4": 23.99,
  "stock": 499,
  "rank": 9,
  "giftSafe": true,
  "matching": [
   "njia-leather-handbag-biggest-sale-deal",
   "njia-leather-backpack-biggest-sale-deal",
   "njia-mini-wallet-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Njia-Studio-1.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Njia_mk_1_e231282b-1df1-4d3f-9e52-989206a7990a.png"
 },
 {
  "handle": "safiya-brown-chain-tote-bag-bs26-deal",
  "variantId": "67950116176148",
  "type": "tote",
  "design": "Safiya Brown Chain",
  "size": "18×12×5.4\" (đáy 11\") · vừa laptop 13\", sách, A4",
  "list": 217.95,
  "p4": 43.59,
  "stock": 208,
  "rank": 100,
  "giftSafe": true,
  "matching": [],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Brown-mk-2_c114d29e-a48a-4bb4-8895-7d2cbdecf371.png",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Brown-mk-1_68a84e9f-500e-419d-80af-c9f85ee9f1f6.png"
 },
 {
  "handle": "aina-coconut-white-circle-crossbody-bag-bs26-deal",
  "variantId": "67930797834516",
  "type": "crossbody",
  "design": "Aina Coconut White",
  "size": "Ø7.5\" × dày 2.5\" · điện thoại, thẻ, chìa khoá, son",
  "list": 89.95,
  "p4": 17.99,
  "stock": 1386,
  "rank": 1,
  "giftSafe": true,
  "matching": [
   "aina-coconut-white-leather-handbag-biggest-sale-deal",
   "aina-coconut-white-small-leather-handbag-biggest-sale-deal",
   "aina-coconut-white-leather-tote-bag-biggest-sale-deal",
   "aina-coconut-white-mini-satchel-biggest-sale-deal",
   "aina-coconut-white-wallet-biggest-sale-deal",
   "aina-coconut-white-mini-wallet-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/33.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/aina-coconut-white_mk_1.png"
 },
 {
  "handle": "imani-blue-orchid-circle-crossbody-bag-biggest-sale-deal",
  "variantId": "67918386102548",
  "type": "crossbody",
  "design": "Imani Blue Orchid",
  "size": "Ø7.5\" × dày 2.5\" · điện thoại, thẻ, chìa khoá, son",
  "list": 89.95,
  "p4": 17.99,
  "stock": 744,
  "rank": 4,
  "giftSafe": true,
  "matching": [
   "imani-blue-orchid-envelope-chain-crossbody-bag-biggest-sale-deal",
   "imani-blue-orchid-wallet-bs26-deal",
   "imani-blue-orchid-mini-wallet-biggest-sale-deal",
   "imani-blue-orchid-eclipse-makeup-bag-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/28.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/imani-blue-orchid_mk_1.png"
 },
 {
  "handle": "sanaa-salt-pop-circle-crossbody-bag-biggest-sale-deal",
  "variantId": "67918398882068",
  "type": "crossbody",
  "design": "Sanaa Salt Pop",
  "size": "Ø7.5\" × dày 2.5\" · điện thoại, thẻ, chìa khoá, son",
  "list": 89.95,
  "p4": 17.99,
  "stock": 1009,
  "rank": 10,
  "giftSafe": true,
  "matching": [
   "sanaa-salt-pop-leather-handbag-biggest-sale-deal",
   "sanaa-salt-pop-leather-tote-bag-biggest-sale-deal",
   "sanaa-salt-pop-leather-backpack-biggest-sale-deal",
   "sanaa-salt-pop-wallet-biggest-sale-deal",
   "sanaa-salt-pop-mini-wallet-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/21.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/sanaa-salt-pop_mk_1.png"
 },
 {
  "handle": "imani-blue-orchid-envelope-chain-crossbody-bag-biggest-sale-deal",
  "variantId": "67920271900948",
  "type": "crossbody",
  "design": "Imani Blue Orchid",
  "size": "8.3×4.7×1.2\" · điện thoại, thẻ, tiền mặt",
  "list": 89.95,
  "p4": 17.99,
  "stock": 639,
  "rank": 4,
  "giftSafe": true,
  "matching": [
   "imani-blue-orchid-circle-crossbody-bag-biggest-sale-deal",
   "imani-blue-orchid-wallet-bs26-deal",
   "imani-blue-orchid-mini-wallet-biggest-sale-deal",
   "imani-blue-orchid-eclipse-makeup-bag-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Imani-Blue-Orchid_outdoor_1.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/images_2Fmockups_2Fimani-blue-orchid_mk_1-7914584674.png"
 },
 {
  "handle": "aina-coconut-white-mini-satchel-biggest-sale-deal",
  "variantId": "67918579138836",
  "type": "crossbody",
  "design": "Aina Coconut White",
  "size": "5.4×7.8×4.2\" · điện thoại, thẻ, chìa khoá, son",
  "list": 89.95,
  "p4": 17.99,
  "stock": 1629,
  "rank": 1,
  "giftSafe": true,
  "matching": [
   "aina-coconut-white-leather-handbag-biggest-sale-deal",
   "aina-coconut-white-small-leather-handbag-biggest-sale-deal",
   "aina-coconut-white-leather-tote-bag-biggest-sale-deal",
   "aina-coconut-white-circle-crossbody-bag-bs26-deal",
   "aina-coconut-white-wallet-biggest-sale-deal",
   "aina-coconut-white-mini-wallet-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Aina-white-2.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/images_2Fmockups_2Faina-white_mk_1-2516966238_05cb002c-4476-4ae8-a75f-788eb9f152d3.png"
 },
 {
  "handle": "locella-mini-satchel-bs26-deal",
  "variantId": "67930837385492",
  "type": "crossbody",
  "design": "Locella",
  "size": "5.4×7.8×4.2\" · điện thoại, thẻ, chìa khoá, son",
  "list": 89.95,
  "p4": 17.99,
  "stock": 656,
  "rank": 7,
  "giftSafe": false,
  "matching": [
   "locella-leather-handbag-biggest-sale-deal",
   "locella-wallet-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Locella-1_eed727f3-b3c5-4a16-83e0-67e511dc4943.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Locella_1_68364b42-f4e9-4c98-9888-08f94e650efa.png"
 },
 {
  "handle": "sanaa-salt-pop-leather-backpack-biggest-sale-deal",
  "variantId": "67930614858004",
  "type": "backpack",
  "design": "Sanaa Salt Pop",
  "size": "10.2×13×5.1\" · vừa A4, iPad/tablet 11\", ví, chai nước nhỏ",
  "list": 169.95,
  "p4": 33.99,
  "stock": 168,
  "rank": 10,
  "giftSafe": true,
  "matching": [
   "sanaa-salt-pop-leather-handbag-biggest-sale-deal",
   "sanaa-salt-pop-leather-tote-bag-biggest-sale-deal",
   "sanaa-salt-pop-circle-crossbody-bag-biggest-sale-deal",
   "sanaa-salt-pop-wallet-biggest-sale-deal",
   "sanaa-salt-pop-mini-wallet-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Sanaa-Salt-Pop-inuse-1.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/images_2Fmockups_2Fsanaa-salt-pop_mk_1-0167967435.png"
 },
 {
  "handle": "njia-leather-backpack-biggest-sale-deal",
  "variantId": "67930614792468",
  "type": "backpack",
  "design": "Njia",
  "size": "10.2×13×5.1\" · vừa A4, iPad/tablet 11\", ví, chai nước nhỏ",
  "list": 169.95,
  "p4": 33.99,
  "stock": 148,
  "rank": 9,
  "giftSafe": true,
  "matching": [
   "njia-leather-handbag-biggest-sale-deal",
   "njia-leather-tote-bag-biggest-sale-deal",
   "njia-mini-wallet-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Njia-inuse-1.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/images_2Fmockups_2Fnjia_mk_1-8587142881.png"
 },
 {
  "handle": "aina-grape-soda-leather-backpack-biggest-sale-deal",
  "variantId": "67930614333716",
  "type": "backpack",
  "design": "Aina Grape Soda",
  "size": "10.2×13×5.1\" · vừa A4, iPad/tablet 11\", ví, chai nước nhỏ",
  "list": 169.95,
  "p4": 33.99,
  "stock": 127,
  "rank": 18,
  "giftSafe": true,
  "matching": [],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/aina-grape-soda-inuse-1.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/images_2Fmockups_2Faina-grape-soda_mk_1-0293036891.png"
 },
 {
  "handle": "fahari-monochrome-leather-backpack-biggest-sale-deal",
  "variantId": "67930614530324",
  "type": "backpack",
  "design": "Fahari Monochrome",
  "size": "10.2×13×5.1\" · vừa A4, iPad/tablet 11\", ví, chai nước nhỏ",
  "list": 169.95,
  "p4": 33.99,
  "stock": 84,
  "rank": 19,
  "giftSafe": true,
  "matching": [],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/fahari-monochrome-inuse-1.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/images_2Fmockups_2Ffahari-monochrome_mk_1-6627297378.png"
 },
 {
  "handle": "aina-coconut-white-wallet-biggest-sale-deal",
  "variantId": "67917951435028",
  "type": "wallet",
  "design": "Aina Coconut White",
  "size": "4.3×7.9×1\" · điện thoại, thẻ, tiền mặt",
  "list": 49.95,
  "p4": 9.99,
  "stock": 12218,
  "rank": 1,
  "giftSafe": true,
  "matching": [
   "aina-coconut-white-leather-handbag-biggest-sale-deal",
   "aina-coconut-white-small-leather-handbag-biggest-sale-deal",
   "aina-coconut-white-leather-tote-bag-biggest-sale-deal",
   "aina-coconut-white-circle-crossbody-bag-bs26-deal",
   "aina-coconut-white-mini-satchel-biggest-sale-deal",
   "aina-coconut-white-mini-wallet-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/AinaRise_SlayWhite1.png",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Aina-Coconut-White_mk_1_e36a441c-7230-4a75-b20f-53d8a75ee221.png"
 },
 {
  "handle": "sanaa-salt-pop-wallet-biggest-sale-deal",
  "variantId": "67917999702292",
  "type": "wallet",
  "design": "Sanaa Salt Pop",
  "size": "4.3×7.9×1\" · điện thoại, thẻ, tiền mặt",
  "list": 49.95,
  "p4": 9.99,
  "stock": 6810,
  "rank": 10,
  "giftSafe": true,
  "matching": [
   "sanaa-salt-pop-leather-handbag-biggest-sale-deal",
   "sanaa-salt-pop-leather-tote-bag-biggest-sale-deal",
   "sanaa-salt-pop-circle-crossbody-bag-biggest-sale-deal",
   "sanaa-salt-pop-leather-backpack-biggest-sale-deal",
   "sanaa-salt-pop-mini-wallet-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/SanaaRise_SlayWhite1.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Sanaa-Salt-Pop_mk_1_dc38e1b7-6826-4139-afaf-c3d3c72f937f.png"
 },
 {
  "handle": "imani-blue-orchid-wallet-bs26-deal",
  "variantId": "67931030946068",
  "type": "wallet",
  "design": "Imani Blue Orchid",
  "size": "4.3×7.9×1\" · điện thoại, thẻ, tiền mặt",
  "list": 49.95,
  "p4": 9.99,
  "stock": 3148,
  "rank": 4,
  "giftSafe": true,
  "matching": [
   "imani-blue-orchid-circle-crossbody-bag-biggest-sale-deal",
   "imani-blue-orchid-envelope-chain-crossbody-bag-biggest-sale-deal",
   "imani-blue-orchid-mini-wallet-biggest-sale-deal",
   "imani-blue-orchid-eclipse-makeup-bag-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/ImaniAffirmation1.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Imani-Blue-Orchid_mk_1_e3b40556-0b9e-4a3b-8a3c-7fe9cd25a696.png"
 },
 {
  "handle": "locella-wallet-biggest-sale-deal",
  "variantId": "67918703132948",
  "type": "wallet",
  "design": "Locella",
  "size": "4.3×7.9×1\" · điện thoại, thẻ, tiền mặt",
  "list": 49.95,
  "p4": 9.99,
  "stock": 1719,
  "rank": 7,
  "giftSafe": false,
  "matching": [
   "locella-leather-handbag-biggest-sale-deal",
   "locella-mini-satchel-bs26-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/let-these-locs-do-the-talking-1.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/images_2Fmockups_2Flet-these-locs-do-the-talking_mk_1-0332494820.png"
 },
 {
  "handle": "zuriya-wallet-biggest-sale-deal",
  "variantId": "67917964149012",
  "type": "wallet",
  "design": "Zuriya",
  "size": "4.3×7.9×1\" · điện thoại, thẻ, tiền mặt",
  "list": 49.95,
  "p4": 9.99,
  "stock": 1880,
  "rank": 8,
  "giftSafe": true,
  "matching": [
   "zuriya-leather-tote-bag-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/ZuriyaBeautiful1.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Zuriya_mk_1_fb4f9d9d-fbf7-4e1c-b6ab-8c5b1751903c.png"
 },
 {
  "handle": "dope-black-mom-wallet-bs26-deal",
  "variantId": "67930777387284",
  "type": "wallet",
  "design": "Dope Black Mom",
  "size": "4.3×7.9×1\" · điện thoại, thẻ, tiền mặt",
  "list": 49.95,
  "p4": 9.99,
  "stock": 1329,
  "rank": 5,
  "giftSafe": false,
  "matching": [
   "dope-black-mom-mini-wallet-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/DopeBlackMom01_166e40d9-3418-4ae5-bda8-e8e40c33f77b.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Dope-Black-Mom_mk_1_67584542-33e0-4742-9942-bdde9af2c288.png"
 },
 {
  "handle": "eliora-wallet-biggest-sale-deal",
  "variantId": "67918707327252",
  "type": "wallet",
  "design": "Eliora",
  "size": "4.3×7.9×1\" · điện thoại, thẻ, tiền mặt",
  "list": 49.95,
  "p4": 9.99,
  "stock": 1487,
  "rank": 3,
  "giftSafe": true,
  "matching": [],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Eliora-1_4429a2fb-d227-4fb1-86e5-0476a57d340d.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Eliora_mk_1_c082f160-8a39-4fe0-bd3a-17370c47df29.png"
 },
 {
  "handle": "aina-coconut-white-mini-wallet-biggest-sale-deal",
  "variantId": "67918637924628",
  "type": "mini wallet",
  "design": "Aina Coconut White",
  "size": "4.5×3.2×1\" · thẻ, tiền mặt, xu, son",
  "list": 39.95,
  "p4": 7.99,
  "stock": 5076,
  "rank": 1,
  "giftSafe": true,
  "matching": [
   "aina-coconut-white-leather-handbag-biggest-sale-deal",
   "aina-coconut-white-small-leather-handbag-biggest-sale-deal",
   "aina-coconut-white-leather-tote-bag-biggest-sale-deal",
   "aina-coconut-white-circle-crossbody-bag-bs26-deal",
   "aina-coconut-white-mini-satchel-biggest-sale-deal",
   "aina-coconut-white-wallet-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Aina-white-1_852555c6-ae19-43b8-be74-c80d23ffcea4.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Aina-Coconut-White_mk_1_75b80a7b-6639-4eb1-a1dc-c241e0ea1a56.png"
 },
 {
  "handle": "sanaa-salt-pop-mini-wallet-biggest-sale-deal",
  "variantId": "67918668693780",
  "type": "mini wallet",
  "design": "Sanaa Salt Pop",
  "size": "4.5×3.2×1\" · thẻ, tiền mặt, xu, son",
  "list": 39.95,
  "p4": 7.99,
  "stock": 3610,
  "rank": 10,
  "giftSafe": true,
  "matching": [
   "sanaa-salt-pop-leather-handbag-biggest-sale-deal",
   "sanaa-salt-pop-leather-tote-bag-biggest-sale-deal",
   "sanaa-salt-pop-circle-crossbody-bag-biggest-sale-deal",
   "sanaa-salt-pop-leather-backpack-biggest-sale-deal",
   "sanaa-salt-pop-wallet-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Sanaa-1_db033f85-841f-4dde-acc5-c131a6de96e8.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Sanaa-Salt-Pop_mk_1_837de6db-4123-4e49-806f-8c485befb0c0.png"
 },
 {
  "handle": "imani-blue-orchid-mini-wallet-biggest-sale-deal",
  "variantId": "67918645330196",
  "type": "mini wallet",
  "design": "Imani Blue Orchid",
  "size": "4.5×3.2×1\" · thẻ, tiền mặt, xu, son",
  "list": 39.95,
  "p4": 7.99,
  "stock": 2721,
  "rank": 4,
  "giftSafe": true,
  "matching": [
   "imani-blue-orchid-circle-crossbody-bag-biggest-sale-deal",
   "imani-blue-orchid-envelope-chain-crossbody-bag-biggest-sale-deal",
   "imani-blue-orchid-wallet-bs26-deal",
   "imani-blue-orchid-eclipse-makeup-bag-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Imani-1_2019eebf-a46c-4bad-ac04-ad6cb1d726bf.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Imani-Blue-Orchid_mk_1_56d687dc-8068-418d-bc66-a5f8766f21ca.png"
 },
 {
  "handle": "njia-mini-wallet-biggest-sale-deal",
  "variantId": "67919026094356",
  "type": "mini wallet",
  "design": "Njia",
  "size": "4.5×3.2×1\" · thẻ, tiền mặt, xu, son",
  "list": 39.95,
  "p4": 7.99,
  "stock": 1640,
  "rank": 9,
  "giftSafe": true,
  "matching": [
   "njia-leather-handbag-biggest-sale-deal",
   "njia-leather-tote-bag-biggest-sale-deal",
   "njia-leather-backpack-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Njia-1_23d4eb26-4f49-4ef8-904c-7db74ab20444.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Njia_mk_1_e2389b83-941a-4ae9-87b2-fe7454fa9301.png"
 },
 {
  "handle": "dope-black-mom-mini-wallet-biggest-sale-deal",
  "variantId": "67919172796692",
  "type": "mini wallet",
  "design": "Dope Black Mom",
  "size": "4.5×3.2×1\" · thẻ, tiền mặt, xu, son",
  "list": 39.95,
  "p4": 7.99,
  "stock": 1298,
  "rank": 5,
  "giftSafe": false,
  "matching": [
   "dope-black-mom-wallet-bs26-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/DopeBlackMom-1.png",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/images_2Fmockups_2Fdope-black-mom_mk_1-4388108539.png"
 },
 {
  "handle": "afroessence-mini-wallet-bs26-deal",
  "variantId": "67939180151060",
  "type": "mini wallet",
  "design": "AfroEssence",
  "size": "4.5×3.2×1\" · thẻ, tiền mặt, xu, son",
  "list": 39.95,
  "p4": 7.99,
  "stock": 1384,
  "rank": 11,
  "giftSafe": true,
  "matching": [],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/AfroEssence-1_3abf5d1b-36f0-4407-a5ff-556241409a80.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/images_2Fmockups_2Fafroessence_mk_1-6000270724.png"
 },
 {
  "handle": "imani-blue-orchid-eclipse-makeup-bag-biggest-sale-deal",
  "variantId": "67918522220820",
  "type": "makeup bag",
  "design": "Imani Blue Orchid",
  "size": "10×7.5×4.75\" · son, cọ, mỹ phẩm, skincare",
  "list": 49.95,
  "p4": 9.99,
  "stock": 457,
  "rank": 4,
  "giftSafe": true,
  "matching": [
   "imani-blue-orchid-circle-crossbody-bag-biggest-sale-deal",
   "imani-blue-orchid-envelope-chain-crossbody-bag-biggest-sale-deal",
   "imani-blue-orchid-wallet-bs26-deal",
   "imani-blue-orchid-mini-wallet-biggest-sale-deal"
  ],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Imani-1_0a2df5b9-01be-4c5f-bc92-fdb8ebe4cc35.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Imani-Blue-Orchid_mk_1_15ccc98a-eaaf-4920-bd27-9f7cf2a8aab6.png"
 },
 {
  "handle": "tajimom-eclipse-makeup-bag-biggest-sale-deal",
  "variantId": "67920257548564",
  "type": "makeup bag",
  "design": "Tajimom",
  "size": "10×7.5×4.75\" · son, cọ, mỹ phẩm, skincare",
  "list": 49.95,
  "p4": 9.99,
  "stock": 151,
  "rank": 21,
  "giftSafe": false,
  "matching": [],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Tajimom_studio_1.jpg",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/images_2Fmockups_2Ftajimom_mk_1-2555063399.png"
 },
 {
  "handle": "tajimom-leather-handbag-biggest-sale-deal",
  "variantId": "67920555475220",
  "type": "handbag",
  "design": "Tajimom",
  "size": "",
  "list": 142.95,
  "p4": 28.59,
  "stock": 1217,
  "rank": 99,
  "giftSafe": true,
  "matching": [],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/dopest-black-mom-periodt_mk_1_b1ed412c-ee78-41e0-bcb1-364e57008121.png?v=1748598664&width=400",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/dopest-black-mom-periodt_mk_1_b1ed412c-ee78-41e0-bcb1-364e57008121.png?v=1748598664&width=400"
 },
 {
  "handle": "tajimom-small-leather-handbag-biggest-sale-deal",
  "variantId": "67919600845076",
  "type": "small handbag",
  "design": "Tajimom",
  "size": "",
  "list": 131.95,
  "p4": 26.39,
  "stock": 231,
  "rank": 99,
  "giftSafe": true,
  "matching": [],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/images_2Fmockups_2Fdopest-black-mom-periodt_mk_1-0110372048.png?v=1766982548&width=400",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/images_2Fmockups_2Fdopest-black-mom-periodt_mk_1-0110372048.png?v=1766982548&width=400"
 },
 {
  "handle": "tajimom-leather-tote-bag-bs26-deal",
  "variantId": "67939177496852",
  "type": "tote",
  "design": "Tajimom",
  "size": "",
  "list": 119.95,
  "p4": 23.99,
  "stock": 626,
  "rank": 99,
  "giftSafe": true,
  "matching": [],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Tajimom_mk_1_0ed15da0-067c-4ec7-bf14-4b2288b74974.png?v=1761125823&width=400",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Tajimom_mk_1_0ed15da0-067c-4ec7-bf14-4b2288b74974.png?v=1761125823&width=400"
 },
 {
  "handle": "dope-black-mom-leather-tote-bag-biggest-sale-deal",
  "variantId": "67917926662420",
  "type": "tote",
  "design": "Dope Black Mom",
  "size": "",
  "list": 119.95,
  "p4": 23.99,
  "stock": 70,
  "rank": 99,
  "giftSafe": true,
  "matching": [],
  "img": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Dope-Black-Mom_mk_1_0f8bcf20-c337-40cc-9eea-3aac412efd2c.png?v=1761125759&width=400",
  "imgClean": "https://cdn.shopify.com/s/files/1/0931/2970/3700/files/Dope-Black-Mom_mk_1_0f8bcf20-c337-40cc-9eea-3aac412efd2c.png?v=1761125759&width=400"
 }
];
